import React from 'react'

const Manual_reporte_ventas_cliente = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Reporte de Ventas por Cliente
        </h2>
        <iframe
          src="https://scribehow.com/embed/Reporte_de_Ventas_por_Cliente__1R8rK7p5RM6MnvNe6PfViA?as=scrollable"
          className="scribe-iframe-general-155"
          width="100%"
          height="4100"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_reporte_ventas_cliente
